import Add from '@mui/icons-material/Add';
import { t } from 'i18next';
import { useContext, useState } from 'react';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';
import { useStores } from '~store';
import { alert, AlertTypes } from '~types/AlertTypes';

import { OwnerContext } from '../context/OwnerContext';
import AutomaticSettlementAddOnsDialog from './AutomaticSettlementAddOnsDialog';
import ScheduleOwnerQueryContext from './ScheduleOwnerQueryContext';

interface CreateAutomaticSettlementAddonButtonProps {
  onScheduleCreated: (ownerName: string) => void;
}

const CreateAutomaticSettlementAddonButton = ({
  onScheduleCreated,
}: CreateAutomaticSettlementAddonButtonProps) => {
  const { toasterStore } = useStores();
  const [openDialog, setOpenDialog] = useState(false);

  const { selectedOwnerId, setSelectedOwner, selectedOwnerType } =
    useContext(OwnerContext);
  const scheduleOwnerQuery = useContext(ScheduleOwnerQueryContext);

  const handleCreateSchedule = () => {
    setSelectedOwner('');
    setOpenDialog(true);
  };

  return (
    <>
      <SmallButton
        color="brandV2Yellow"
        startIcon={<Add />}
        sx={{ flexShrink: 0, m: 1.5 }}
        onClick={handleCreateSchedule}
      >
        {t('administration.automatic_settlement_add_ons.create_schedule')}
      </SmallButton>
      <AutomaticSettlementAddOnsDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onSuccess={(ownerId: string, ownerName: string) => {
          scheduleOwnerQuery.refresh();
          setSelectedOwner(ownerId, ownerName);
          onScheduleCreated(ownerName);

          toasterStore.push(
            alert(
              t('administration.automatic_settlement_add_ons.add_on_added'),
              AlertTypes.success,
            ),
          );
        }}
        selectedOwnerId={selectedOwnerId}
        selectedOwnerType={selectedOwnerType}
      />
    </>
  );
};

export default CreateAutomaticSettlementAddonButton;
